import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable()
export class LoadingSpinnerService {

  private _counter = 0;

  constructor(
    private ngxSpinnerService: NgxSpinnerService,
  ) {
  }

  get hasSpinner(): boolean {
    return this._counter > 0 ;
  }

  private _log(message: string): void {
    // console.warn(message);
  }

  show(): void {
    const before = this._counter;
    this._counter++;
    this._updateVisible();
    this._log(`show: before ${before}, current: ${this._counter}`);
  }

  hide(): void {
    const before = this._counter;
    this._counter--;
    if (this._counter < 0) {
      this._counter = 0;
    }
    this._log(`show: before ${before}, current: ${this._counter}`);
    this._updateVisible();
  }

  _updateVisible(): void {
    if (this._counter > 0) {
      this._log(`spinner show`);
      this.ngxSpinnerService.show();
    } else {
      this._log(`spinner hide`);
      this.ngxSpinnerService.hide();
    }
  }
}
